import { BrowserModule } from '@angular/platform-browser';
import {APP_INITIALIZER, NgModule} from '@angular/core';
import { AngularDualListBoxModule } from 'angular-dual-listbox';
import { Ng2PaginationModule} from 'ng2-pagination';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PublicModule } from './public/public.module';
import { DashboardModule } from './dashboard/dashboard.module';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {HttpClient, HttpClientModule} from '@angular/common/http';
import { UserRolesComponent } from './full-pages-admin-panel/user-mgt/user-roles/user-roles.component';
import {AuthService} from './shared/service/auth.service';
import {SessionService} from './shared/service/session.service';
import {SysConfigService} from './shared/service/sys-config.service';
import {UserRoleService} from './shared/service/userrole.service';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {UserroleCategoryService} from './shared/service/userrole-category.service';
import {UserRolesSearchTableComponent} from './full-pages-admin-panel/user-mgt/user-roles/user-roles-search-table/user-roles-search-table.component';
import {UserRolePopupComponent} from './full-pages-admin-panel/user-mgt/user-roles/user-role-popup/user-role-popup.component';
import {EmployeeComponent} from './full-pages-admin-panel/employee-mgt/employee/employee.component';
import {EmployeeSearchTableComponent} from './full-pages-admin-panel/employee-mgt/employee/employee-search-table/employee-search-table.component';
import {EmployeePopupComponent} from './full-pages-admin-panel/employee-mgt/employee/employee-popup/employee-popup.component';
import {EmployeeDesignationService} from './shared/service/employee-designation.service';
import {EmployeeService} from './shared/service/employee.service';
import {SystemUserPopupComponent} from './full-pages-admin-panel/employee-mgt/employee/system-user-popup/system-user-popup.component';
import { ChartsModule } from 'ng2-charts';
import { PaymentComponent } from './payment/payment.component';
import {
    MatCardModule, MatCheckboxModule,
    MatFormFieldModule,
    MatInputModule,
    MatPaginatorModule, MatProgressBarModule, MatProgressSpinnerModule, MatSortModule,
    MatTableModule,
    MatTabsModule,
} from '@angular/material';
import {MatDatepickerModule} from '@angular/material';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { PaymentScreenComponent } from './payment/payment-screen/payment-screen.component';
import {UserRolesCategoryComponent} from './full-pages-admin-panel/user-mgt/user-roles-category/user-roles-category.component';
import {UserRoleCategoryPopupComponent} from './full-pages-admin-panel/user-mgt/user-roles-category/user-role-category-popup/user-role-category-popup.component';
import {UserRoleCategorSearchTableComponent} from './full-pages-admin-panel/user-mgt/user-roles-category/user-role-categor-search-table/user-role-categor-search-table.component';
import {AssignWorkflowStageComponent} from './full-pages-admin-panel/assign-workflow-stage/assign-workflow-stage.component';
import {WorkflowStageService} from './shared/service/workflow-stage.service';
import {OperationPrivilageService} from './shared/service/operation-privilage.service';
import {PageService} from './shared/service/page.service';
import {SectionService} from './shared/service/section.service';
import {SubSectionService} from './shared/service/sub-section.service';
import {UserPrivilegeService} from './shared/service/user-privilege.service';
import {UserPrivilegeComponent} from './full-pages-admin-panel/user-mgt/user-privilege/user-privilege.component';
import {UserPrivilegeTableComponent} from './full-pages-admin-panel/user-mgt/user-privilege/user-privilege-table/user-privilege-table.component';
import {EmployeeDesignationComponent} from './full-pages-admin-panel/employee-mgt/employee-designation/employee-designation.component';
import {EmployeeDesignationPopupComponent} from './full-pages-admin-panel/employee-mgt/employee-designation/employee-designation-popup/employee-designation-popup.component';
import {EmployeeDesignationSearchTableComponent} from './full-pages-admin-panel/employee-mgt/employee-designation/employee-designation-search-table/employee-designation-search-table.component';
import {SystemUserService} from './shared/service/system-user.service';
import {ProvinceComponent} from './full-pages-admin-panel/location-mgt/province/province.component';
import {CityComponent} from './full-pages-admin-panel/location-mgt/city/city.component';
import {DistrictComponent} from './full-pages-admin-panel/location-mgt/district/district.component';
import {ProvincePopupComponent} from './full-pages-admin-panel/location-mgt/province/province-popup/province-popup.component';
import {ProvinceSearchTableComponent} from './full-pages-admin-panel/location-mgt/province/province-search-table/province-search-table.component';
import {CityPopupComponent} from './full-pages-admin-panel/location-mgt/city/city-popup/city-popup.component';
import {CitySearchTableComponent} from './full-pages-admin-panel/location-mgt/city/city-search-table/city-search-table.component';
import {DistrictPopupComponent} from './full-pages-admin-panel/location-mgt/district/district-popup/district-popup.component';
import {DistrictSearchTableComponent} from './full-pages-admin-panel/location-mgt/district/district-search-table/district-search-table.component';
import {ProvinceService} from './shared/service/province.service';
import {DistrictService} from './shared/service/district.service';
import {CityService} from './shared/service/city.service';
import { ApprovalProcessComponent } from './approval-process/approval-process.component';
import { ApprovalPendingListComponent } from './approval-process/approval-pending-list/approval-pending-list.component';
import {NationalityComponent} from './full-pages-admin-panel/nationality-mgt/nationality/nationality.component';
import {NationalityPopupComponent} from './full-pages-admin-panel/nationality-mgt/nationality/nationality-popup/nationality-popup.component';
import {NationalitySearchTableComponent} from './full-pages-admin-panel/nationality-mgt/nationality/nationality-search-table/nationality-search-table.component';
import {NationalityService} from './shared/service/nationality.service';
import {TokenStorageService} from './shared/service/token-storage.service';
import {CustomPaginationComponentComponent} from './full-pages-admin-panel/custom-pagination-component/custom-pagination-component.component';
import {AssignWorkflowStageSearchTableComponent} from './full-pages-admin-panel/assign-workflow-stage/assign-workflow-stage-search-table/assign-workflow-stage-search-table.component';
import { RequestSearchComponent } from './dashboard/request-search/request-search.component';
import {OwlDateTimeModule, OwlNativeDateTimeModule} from 'ng-pick-datetime';
import {SearchRequestService} from './shared/service/search-request.service';
import {RequestSearchTableComponent} from './dashboard/request-search/request-search-table/request-search-table.component';
import {RequestSearchHistoryComponent} from './dashboard/request-search/request-search-detail/request-search-history/request-search-history.component';
import {RequestSearchDetailComponent} from './dashboard/request-search/request-search-detail/request-search-detail.component';
import {PaymentInfoComponent} from './dashboard/request-search/request-search-detail/payment-info/payment-info.component';
import {NgxUiLoaderModule} from 'ngx-ui-loader';
import {NgxDropzoneModule} from 'ngx-dropzone';
import {NgWizardConfig, NgWizardModule, THEME} from 'ng-wizard';
import {BiometricInfoComponent} from './dashboard/request-search/request-search-detail/biometric-info/biometric-info.component';
import {HistoryInfoComponent} from './dashboard/request-search/request-search-detail/history-info/history-info.component';
import {BoarderMgtComponent} from './full-pages-admin-panel/boarder-mgt/boarder-mgt.component';
import {BoarderPopupComponent} from './full-pages-admin-panel/boarder-mgt/boarder-popup/boarder-popup.component';


const ngWizardConfig: NgWizardConfig = {
  theme: THEME.default
};
import { ApprovalProcessRequestViewerComponent } from './approval-process/approval-process-request-viewer/approval-process-request-viewer.component';
import { ApplicantDataComponent } from './approval-process/approval-process-request-viewer/applicant-data/applicant-data.component';
import { RequestHistoryComponent } from './approval-process/approval-process-request-viewer/request-history/request-history.component';
import { DocumentViwerComponent } from './approval-process/approval-process-request-viewer/document-viwer/document-viwer.component';
import {DocumentViewerComponent} from './approval-process/approval-process-request-viewer/document-viewer/document-viewer.component';
import {MatDialogModule, MatDialogRef, MatIconModule} from '@angular/material';
import { RemarkComponent } from './approval-process/remark/remark.component';
import { FwdRemarkComponent } from './approval-process/fwd-remark/fwd-remark.component';
import { ReturnRemarkComponent } from './approval-process/return-remark/return-remark.component';
import { ApproveChecklistComponent } from './approval-process/approve-checklist/approve-checklist.component';
import { DuplicateApplicantRequestComponent } from './approval-process/approval-process-request-viewer/duplicate-applicant-request/duplicate-applicant-request.component';
import { CardPreviewComponent } from './approval-process/approval-process-request-viewer/card-preview/card-preview.component';
import { DispatchProcessComponent } from './dispatch-process/dispatch-process.component';
import { ScanPendingListComponent } from './dispatch-process/scan-pending-list/scan-pending-list.component';
import {BlacklistProcessRequestViewerComponent} from './blacklist-process/blacklist-process-request-viewer/blacklist-process-request-viewer.component';
import { BlacklistProcessComponent } from './blacklist-process/blacklist-process.component';
import { ApplicantDetailsComponent } from './blacklist-process/blacklist-process-request-viewer/applicant-details/applicant-details.component';
import { DocumentDetailsComponent } from './blacklist-process/blacklist-process-request-viewer/document-details/document-details.component';
import {UploadDocumentComponent} from './dashboard/online-application-detail/upload-document/upload-document.component';
import { BlacklistDetailsComponent } from './blacklist-process/blacklist-process-request-viewer/blacklist-details/blacklist-details.component';
import { BlacklistProcessVerificationComponent } from './blacklist-process/blacklist-process-verification/blacklist-process-verification.component';
import { BlacklistVerificationRequestViewerComponent } from './blacklist-process/blacklist-process-verification/blacklist-verification-request-viewer/blacklist-verification-request-viewer.component';
import { RemarkDetailsComponent } from './blacklist-process/blacklist-process-verification/blacklist-verification-request-viewer/remark-details/remark-details.component';
import { ApplicationDetailsComponent } from './blacklist-process/blacklist-process-verification/blacklist-verification-request-viewer/application-details/application-details.component';
import { BlacklistProcessAuthorizationComponent } from './blacklist-process/blacklist-process-authorization/blacklist-process-authorization.component';
import { BlacklistAuthorizationRequestViewerComponent } from './blacklist-process/blacklist-process-authorization/blacklist-authorization-request-viewer/blacklist-authorization-request-viewer.component';
import { RemarkHistoryComponent } from './blacklist-process/blacklist-process-authorization/blacklist-authorization-request-viewer/remark-history/remark-history.component';
import { ApplicantHistoryComponent } from './blacklist-process/blacklist-process-authorization/blacklist-authorization-request-viewer/applicant-history/applicant-history.component';
import { ReturnRequestDetailsComponent } from './blacklist-process/blacklist-process-request-viewer/return-request-details/return-request-details.component';
import {ReturnRequestComponent} from './blacklist-process/blacklist-process-verification/blacklist-verification-request-viewer/return-request/return-request.component';
import { RemarksComponent } from './blacklist-process/blacklist-process-request-viewer/remarks/remarks.component';
import { ReturnApplicantDetailsComponent } from './blacklist-process/blacklist-process-request-viewer/return-request-details/return-applicant-details/return-applicant-details.component';
import { ReturnRequestViewerComponent } from './blacklist-process/blacklist-process-request-viewer/return-request-details/return-request-viewer/return-request-viewer.component';
import { BlacklistReturnRequestComponent } from './blacklist-process/blacklist-process-request-viewer/return-request-details/blacklist-return-request/blacklist-return-request.component';
import { ReturnBlacklistRequestDetailsComponent } from './blacklist-process/blacklist-process-authorization/blacklist-authorization-request-viewer/return-blacklist-request-details/return-blacklist-request-details.component';
import { BlacklistReturnRequestViewerComponent } from './blacklist-process/blacklist-process-verification/blacklist-return-request-viewer/blacklist-return-request-viewer.component';
import { ReturnApplicantionDetailsComponent } from './blacklist-process/blacklist-process-verification/blacklist-return-request-viewer/return-applicantion-details/return-applicantion-details.component';
import { ScanPendingDataComponent } from './dispatch-process/scan-pending-list/scan-pending-data/scan-pending-data.component';
import { CardDispatchComponent } from './dispatch-process/card-dispatch/card-dispatch.component';
import { PostListComponent } from './dispatch-process/card-dispatch/post-list/post-list.component';
import { ManualDispatchComponent } from './dispatch-process/card-dispatch/manual-dispatch/manual-dispatch.component';
import { SidApplicantDataComponent } from './dispatch-process/card-dispatch/manual-dispatch/sid-applicant-data/sid-applicant-data.component';
import {UploadSidScanComponent} from './dispatch-process/scan-pending-list/upload-sid-scan/upload-sid-scan.component';
import { ReversedBlacklistProcessComponent } from './reversed-blacklist-process/reversed-blacklist-process.component';
import { ReversedProcessVerificationComponent } from './reversed-blacklist-process/reversed-process-verification/reversed-process-verification.component';
import { ReversedBlacklistVerificationRequestViewerComponent } from './reversed-blacklist-process/reversed-process-verification/reversed-blacklist-verification-request-viewer/reversed-blacklist-verification-request-viewer.component';
import { ReversedApplicantDetailsComponent } from './reversed-blacklist-process/reversed-process-verification/reversed-blacklist-verification-request-viewer/reversed-applicant-details/reversed-applicant-details.component';
import { ReveredBlacklistRemarkDetailsComponent } from './reversed-blacklist-process/reversed-process-verification/reversed-blacklist-verification-request-viewer/revered-blacklist-remark-details/revered-blacklist-remark-details.component';
import { ReversedReturnRequestComponent } from './reversed-blacklist-process/reversed-process-verification/reversed-blacklist-verification-request-viewer/reversed-return-request/reversed-return-request.component';
import { ReversedBlacklistReturnRequestViewerComponent } from './reversed-blacklist-process/reversed-process-verification/reversed-blacklist-return-request-viewer/reversed-blacklist-return-request-viewer.component';
import { ReversedReturnApplicationDetailsComponent } from './reversed-blacklist-process/reversed-process-verification/reversed-blacklist-return-request-viewer/reversed-return-application-details/reversed-return-application-details.component';
import { ReversedProcessRequestViewerComponent } from './reversed-blacklist-process/reversed-process-request-viewer/reversed-process-request-viewer.component';
import { ApplicantsDetailsComponent } from './reversed-blacklist-process/reversed-process-request-viewer/applicants-details/applicants-details.component';
import { ReversedBlacklistDetailsComponent } from './reversed-blacklist-process/reversed-process-request-viewer/reversed-blacklist-details/reversed-blacklist-details.component';
import { ReversedDocumentDetailsComponent } from './reversed-blacklist-process/reversed-process-request-viewer/reversed-document-details/reversed-document-details.component';
import { ReversedRemarksComponent } from './reversed-blacklist-process/reversed-process-request-viewer/reversed-remarks/reversed-remarks.component';
import { ReversedReturnRequestDetailsComponent } from './reversed-blacklist-process/reversed-process-request-viewer/reversed-return-request-details/reversed-return-request-details.component';
import { ReversedBlacklistReturnRequestComponent } from './reversed-blacklist-process/reversed-process-request-viewer/reversed-return-request-details/reversed-blacklist-return-request/reversed-blacklist-return-request.component';
import { ReversedReturnApplicantDetailsComponent } from './reversed-blacklist-process/reversed-process-request-viewer/reversed-return-request-details/reversed-return-applicant-details/reversed-return-applicant-details.component';
import { ReversedReturnRequestViewerComponent } from './reversed-blacklist-process/reversed-process-request-viewer/reversed-return-request-details/reversed-return-request-viewer/reversed-return-request-viewer.component';
import { ReversedProcessAuthorizationComponent } from './reversed-blacklist-process/reversed-process-authorization/reversed-process-authorization.component';
import { ReversedBlacklistAuthorizationRequestViewerComponent } from './reversed-blacklist-process/reversed-process-authorization/reversed-blacklist-authorization-request-viewer/reversed-blacklist-authorization-request-viewer.component';
import { ReversedApplicantHistoryComponent } from './reversed-blacklist-process/reversed-process-authorization/reversed-blacklist-authorization-request-viewer/reversed-applicant-history/reversed-applicant-history.component';
import { ReveresedRemarkHistoryComponent } from './reversed-blacklist-process/reversed-process-authorization/reversed-blacklist-authorization-request-viewer/reveresed-remark-history/reveresed-remark-history.component';
import { ReversedReturnBlacklistRequestDetailsComponent } from './reversed-blacklist-process/reversed-process-authorization/reversed-blacklist-authorization-request-viewer/reversed-return-blacklist-request-details/reversed-return-blacklist-request-details.component';
import { ReversedBlacklistDocumentViewerComponent } from './reversed-blacklist-process/reversed-process-verification/reversed-blacklist-verification-request-viewer/reversed-blacklist-document-viewer/reversed-blacklist-document-viewer.component';
import { BlacklistDocsViewerComponent } from './reversed-blacklist-process/blacklist-docs-viewer/blacklist-docs-viewer.component';
import { SuspendProcessComponent } from './suspend-process/suspend-process.component';
import { SuspendReturnRequestComponent } from './suspend-process/suspend-return-request/suspend-return-request.component';
import { SuspendReturnApplicantComponent } from './suspend-process/suspend-return-request/suspend-return-applicant/suspend-return-applicant.component';
import { SuspendRemarksComponent } from './suspend-process/suspend-return-request/suspend-remarks/suspend-remarks.component';
import { SuspendProcessVerificationComponent } from './suspend-process/suspend-process-verification/suspend-process-verification.component';
import { SuspendVerificationRequestViewerComponent } from './suspend-process/suspend-process-verification/suspend-verification-request-viewer/suspend-verification-request-viewer.component';
import { SupendApplicantDetailsComponent } from './suspend-process/suspend-process-verification/supend-applicant-details/supend-applicant-details.component';
import { SuspendProcessAuthorizationComponent } from './suspend-process/suspend-process-authorization/suspend-process-authorization.component';
import { SuspendAuthorizationRequestViewerComponent } from './suspend-process/suspend-process-authorization/suspend-authorization-request-viewer/suspend-authorization-request-viewer.component';
import { SuspendApplicantHistoryComponent } from './suspend-process/suspend-process-authorization/suspend-authorization-request-viewer/suspend-applicant-history/suspend-applicant-history.component';
import { ReturnSuspendRequestDetailsComponent } from './suspend-process/suspend-process-authorization/suspend-authorization-request-viewer/return-suspend-request-details/return-suspend-request-details.component';
import { BlacklistApproveChecklistComponent } from './blacklist-process/blacklist-approve-checklist/blacklist-approve-checklist.component';
import { SuspendDetailsComponent } from './blacklist-process/blacklist-process-request-viewer/suspend-details/suspend-details.component';
import { ReversedSuspendProcessComponent } from './reversed-suspend-process/reversed-suspend-process.component';
import { ReversedSuspendRequestViewerComponent } from './reversed-suspend-process/reversed-suspend-request-viewer/reversed-suspend-request-viewer.component';
import { ReversedSuspendApplicantDetailsComponent } from './reversed-suspend-process/reversed-suspend-request-viewer/reversed-suspend-applicant-details/reversed-suspend-applicant-details.component';
import { ReversedSuspendDocumentDetailsComponent } from './reversed-suspend-process/reversed-suspend-request-viewer/reversed-suspend-document-details/reversed-suspend-document-details.component';
import { ReversedSuspendVerification } from './reversed-suspend-process/reversed-suspend-verification/reversed-suspend-verification.component';
import { ReversedSuspendVerifiyApplicantDetailsComponent } from './reversed-suspend-process/reversed-suspend-verification/reversed-suspend-verification-request-viewer/reversed-suspend-verifiy-applicant-details/reversed-suspend-verifiy-applicant-details.component';
import { ReversedSuspendVerifyDocumentViewerComponent } from './reversed-suspend-process/reversed-suspend-verification/reversed-suspend-verification-request-viewer/reversed-suspend-verify-document-viewer/reversed-suspend-verify-document-viewer.component';
import { ReversedSuspendVerificationRequestViewerComponent } from './reversed-suspend-process/reversed-suspend-verification/reversed-suspend-verification-request-viewer/reversed-suspend-verification-request-viewer.component';
import { ReversedSuspendAuthorizationComponent } from './reversed-suspend-process/reversed-suspend-authorization/reversed-suspend-authorization.component';
import { ReversedSuspendAuthorizationRequestViewerComponent } from './reversed-suspend-process/reversed-suspend-authorization/reversed-suspend-authorization-request-viewer/reversed-suspend-authorization-request-viewer.component';
// import { ReversedSuspendAuthorizeApplicantDetailsComponent } from './reversed-suspend-process/reversed-suspend-authorization/reversed-suspend-authorization-request-viewer/reversed-suspend-authorize-applicant-details/reversed-suspend-authorize-applicant-details.component';
import { ReversedSuspendAuthorizeApplicantDetailsComponent } from './reversed-suspend-process/reversed-suspend-authorization/reversed-suspend-authorization-request-viewer/reversed-suspend-authorize-applicant-details/reversed-suspend-authorize-applicant-details.component'
import { ReversedSuspendReturnRequestsComponent } from './reversed-suspend-process/reversed-suspend-return-requests/reversed-suspend-return-requests.component';
import { ReversedSuspendReturnApplicantDetailsComponent } from './reversed-suspend-process/reversed-suspend-return-requests/reversed-suspend-return-applicant-details/reversed-suspend-return-applicant-details.component';
import { ReversedSuspendReturnRequestViewerComponent } from './reversed-suspend-process/reversed-suspend-return-request-viewer/reversed-suspend-return-request-viewer.component';
import {ImageViewerModule} from 'ngx-image-viewer';
import { ReversedSuspendBlacklistComponent } from './reversed-suspend-blacklist/reversed-suspend-blacklist.component';
import { ReversedSuspendBlacklistRequestViewerComponent } from './reversed-suspend-blacklist/reversed-suspend-blacklist-request-viewer/reversed-suspend-blacklist-request-viewer.component';
import { ReversedSuspendBlacklistApplicantComponent } from './reversed-suspend-blacklist/reversed-suspend-blacklist-request-viewer/reversed-suspend-blacklist-applicant/reversed-suspend-blacklist-applicant.component';
import { ReversedSuspendBlacklistDocumentsComponent } from './reversed-suspend-blacklist/reversed-suspend-blacklist-request-viewer/reversed-suspend-blacklist-documents/reversed-suspend-blacklist-documents.component';
import { ReversedSuspendBlacklistVerificationComponent } from './reversed-suspend-blacklist/reversed-suspend-blacklist-verification/reversed-suspend-blacklist-verification.component';
import { ReversedSuspendBlacklistVerificationViewerComponent } from './reversed-suspend-blacklist/reversed-suspend-blacklist-verification/reversed-suspend-blacklist-verification-viewer/reversed-suspend-blacklist-verification-viewer.component';
import { ReversedSuspendBlacklistVerifyApplicantComponent } from './reversed-suspend-blacklist/reversed-suspend-blacklist-verification/reversed-suspend-blacklist-verification-viewer/reversed-suspend-blacklist-verify-applicant/reversed-suspend-blacklist-verify-applicant.component';
import { ReversedSuspendBlacklistVerifyDocumentComponent } from './reversed-suspend-blacklist/reversed-suspend-blacklist-verification/reversed-suspend-blacklist-verification-viewer/reversed-suspend-blacklist-verify-document/reversed-suspend-blacklist-verify-document.component';
import { ReversedSupendBlacklistAuthorizationComponent } from './reversed-suspend-blacklist/reversed-supend-blacklist-authorization/reversed-supend-blacklist-authorization.component';
import { ReversedSuspBlackAuthApplicantComponent } from './reversed-suspend-blacklist/reversed-supend-blacklist-authorization/reversed-supend-blacklist-authorization-request-viewer/reversed-susp-black-auth-applicant-details/reversed-susp-black-auth-applicant.component';
import { ReversedSuspBlackAuthRequestViewerComponent } from './reversed-suspend-blacklist/reversed-supend-blacklist-authorization/reversed-supend-blacklist-authorization-request-viewer/reversed-susp-black-auth-request-viewer.component';
import { ReversedSuspendBlacklistReturnComponent } from './reversed-suspend-blacklist/reversed-suspend-blacklist-return/reversed-suspend-blacklist-return.component';
import { ReversedSuspendBlacklistReturnApplicantsComponent } from './reversed-suspend-blacklist/reversed-suspend-blacklist-return/reversed-suspend-blacklist-return-applicants/reversed-suspend-blacklist-return-applicants.component';
import { ReversedSuspendBlacklistReturnRequestViewerComponent } from './reversed-suspend-blacklist/reversed-suspend-blacklist-return-request-viewer/reversed-suspend-blacklist-return-request-viewer.component';
import { SuspendBlacklistProcessComponent } from './suspend-blacklist-process/suspend-blacklist-process.component';
import { SuspendBlacklistProcessViewerComponent } from './suspend-blacklist-process/suspend-blacklist-process-viewer/suspend-blacklist-process-viewer.component';
import { SuspendBlacklistAuthorizationComponent } from './suspend-blacklist-process/suspend-blacklist-authorization/suspend-blacklist-authorization.component';
import { SuspendBlacklistVerificationComponent } from './suspend-blacklist-process/suspend-blacklist-process-viewer/suspend-blacklist-verification/suspend-blacklist-verification.component';
import { SuspendBlacklistAuthorizationViewerComponent } from './suspend-blacklist-process/suspend-blacklist-authorization/suspend-blacklist-authorization-viewer/suspend-blacklist-authorization-viewer.component';
import { SuspendBlacklistReturnDataComponent } from './suspend-blacklist-process/suspend-blacklist-return-data/suspend-blacklist-return-data.component';
import { SuspendBlacklistRerurnViewerComponent } from './suspend-blacklist-process/suspend-blacklist-return-data/suspend-blacklist-rerurn-viewer/suspend-blacklist-rerurn-viewer.component';
import { SuspendBlacklistReturnRequestsComponent } from './suspend-blacklist-process/suspend-blacklist-process-viewer/suspend-blacklist-return-requests/suspend-blacklist-return-requests.component';
import {Ng2LoadingSpinnerModule} from 'ng2-loading-spinner';
import {HashLocationStrategy, LocationStrategy} from '@angular/common';
import { CardPreviewPopupComponent } from './approval-process/approval-process-request-viewer/card-preview-popup/card-preview-popup.component';
import { DocumentViwerPopupComponent } from './approval-process/approval-process-request-viewer/document-viwer-popup/document-viwer-popup.component';
import { DocumentViewerPopupComponent } from './approval-process/approval-process-request-viewer/document-viewer-popup/document-viewer-popup.component';
import {AddNewComponent} from './full-pages-admin-panel/inventory-details/add-new/add-new.component';
import {StageChangeMgtComponent} from './full-pages-admin-panel/stage-change-mgt/stage-change-mgt.component';
import {InventorySearchTableComponent} from './full-pages-admin-panel/inventory-details/inventory-search-table/inventory-search-table.component';
import {InventoryDetailsComponent} from './full-pages-admin-panel/inventory-details/inventory-details.component';
import { PaymentDetailComponent } from './reports/payment-detail-report/payment-detail/payment-detail.component';
import {EditInventryDetailsComponent} from './full-pages-admin-panel/inventory-details/edit-inventry-details/edit-inventry-details.component';
import {MatTableExporterModule} from 'mat-table-exporter';
import { AuditTraceDetailsComponent } from './reports/audit-trace-report/audit-trace-details/audit-trace-details.component';
import { SmsReportComponent } from './reports/sms-report/sms-report.component';
import {SmsMgtComponent} from './full-pages-admin-panel/sms-mgt/sms-mgt.component';
import {SmsSearchTableComponent} from './full-pages-admin-panel/sms-mgt/sms-search-table/sms-search-table.component';
import {SmsPopupComponent} from './full-pages-admin-panel/sms-mgt/sms-popup/sms-popup.component';
import {StageChangePopupComponent} from './full-pages-admin-panel/stage-change-mgt/stage-change-popup/stage-change-popup.component';
import { StudioStatusReportComponent } from './reports/studio-status-report/studio-status-report.component';
import {InactivityService} from './service/inactivity.service';
import {AppConfig} from './shared/common/app.config';

export function initConfig(config: AppConfig) {
  return () => config.load();
}

@NgModule({
  declarations: [
    AppComponent,
    UserRolesComponent,
    CardPreviewPopupComponent,
    DocumentViewerPopupComponent,
    DocumentViwerPopupComponent,
    UserRolesSearchTableComponent,
    UserRolePopupComponent,
    EmployeeComponent,
    EmployeeSearchTableComponent,
    EmployeePopupComponent,
    SystemUserPopupComponent,
    // UploadDocumentComponent,
    // DocumentDetailsComponent
    PaymentComponent,
    PaymentScreenComponent,
    SystemUserPopupComponent,
    UserPrivilegeComponent,
    UserPrivilegeTableComponent,
    EmployeeDesignationComponent,
    EmployeeDesignationPopupComponent,
    EmployeeDesignationSearchTableComponent,
    SystemUserPopupComponent,
    UserRolesCategoryComponent,
    UserRoleCategoryPopupComponent,
    UserRoleCategorSearchTableComponent,
    AssignWorkflowStageComponent,
    ProvinceComponent,
    CityComponent,
    DistrictComponent,
    ProvincePopupComponent,
    ProvinceSearchTableComponent,
    CityPopupComponent,
    CitySearchTableComponent,
    DistrictPopupComponent,
    DistrictSearchTableComponent,
    ApprovalProcessComponent,
    ApprovalPendingListComponent,
    DistrictSearchTableComponent,
    NationalityComponent,
    NationalityPopupComponent,
    NationalitySearchTableComponent,
    CustomPaginationComponentComponent,
    AssignWorkflowStageSearchTableComponent,
    ApprovalProcessRequestViewerComponent,
    ApplicantDataComponent,
    RequestHistoryComponent,
    DocumentViwerComponent,
    DocumentViewerComponent,
    RemarkComponent,
    FwdRemarkComponent,
    ReturnRemarkComponent,
    ApproveChecklistComponent,
    DuplicateApplicantRequestComponent,
    AssignWorkflowStageSearchTableComponent,
    RequestSearchComponent,
    RequestSearchTableComponent,
    RequestSearchDetailComponent,
    RequestSearchHistoryComponent,
    PaymentInfoComponent,
    BiometricInfoComponent,
    HistoryInfoComponent,
    CardPreviewComponent,
    BlacklistProcessComponent,
    BlacklistProcessRequestViewerComponent,
    CardPreviewComponent,
    DispatchProcessComponent,
    ScanPendingListComponent,
    // UploadDocumentComponent,
    ApplicantDetailsComponent,
    DocumentDetailsComponent,
    BlacklistDetailsComponent,
    BlacklistProcessVerificationComponent,
    BlacklistVerificationRequestViewerComponent,
    RemarkDetailsComponent,
    ApplicationDetailsComponent,
    BlacklistProcessAuthorizationComponent,
    BlacklistAuthorizationRequestViewerComponent,
    RemarkHistoryComponent,
    ApplicantHistoryComponent,
    ReturnRequestDetailsComponent,
    ReturnRequestComponent,
    RemarksComponent,
    ReturnApplicantDetailsComponent,
    ReturnRequestViewerComponent,
    BlacklistReturnRequestComponent,
    ReturnBlacklistRequestDetailsComponent,
    BlacklistReturnRequestViewerComponent,
    ReturnApplicantionDetailsComponent,
    ScanPendingDataComponent,
    CardDispatchComponent,
    PostListComponent,
    ManualDispatchComponent,
    SidApplicantDataComponent,
    UploadSidScanComponent,
    ReversedBlacklistProcessComponent,
    ReversedProcessVerificationComponent,
    ReversedBlacklistVerificationRequestViewerComponent,
    ReversedApplicantDetailsComponent,
    ReveredBlacklistRemarkDetailsComponent,
    ReversedReturnRequestComponent,
    ReversedBlacklistReturnRequestViewerComponent,
    ReversedReturnApplicationDetailsComponent,
    ReversedProcessRequestViewerComponent,
    ApplicantsDetailsComponent,
    ReversedBlacklistDetailsComponent,
    ReversedDocumentDetailsComponent,
    ReversedRemarksComponent,
    ReversedReturnRequestDetailsComponent,
    ReversedBlacklistReturnRequestComponent,
    ReversedReturnApplicantDetailsComponent,
    ReversedReturnRequestViewerComponent,
    ReversedProcessAuthorizationComponent,
    ReversedBlacklistAuthorizationRequestViewerComponent,
    ReversedApplicantHistoryComponent,
    ReveresedRemarkHistoryComponent,
    ReversedReturnBlacklistRequestDetailsComponent,
    ReversedBlacklistDocumentViewerComponent,
    BlacklistDocsViewerComponent,
    SuspendProcessComponent,
    SuspendReturnRequestComponent,
    SuspendReturnApplicantComponent,
    SuspendRemarksComponent,
    SuspendProcessVerificationComponent,
    SuspendVerificationRequestViewerComponent,
    SupendApplicantDetailsComponent,
    SuspendProcessAuthorizationComponent,
    SuspendAuthorizationRequestViewerComponent,
    SuspendApplicantHistoryComponent,
    ReturnSuspendRequestDetailsComponent,
    BlacklistApproveChecklistComponent,
    SuspendDetailsComponent,
    ReversedSuspendProcessComponent,
    ReversedSuspendRequestViewerComponent,
    ReversedSuspendApplicantDetailsComponent,
    ReversedSuspendDocumentDetailsComponent,
    ReversedSuspendVerification,
    ReversedSuspendVerifiyApplicantDetailsComponent,
    ReversedSuspendVerifyDocumentViewerComponent,
    ReversedSuspendVerificationRequestViewerComponent,
    ReversedSuspendAuthorizationComponent,
    ReversedSuspendAuthorizationRequestViewerComponent,
    ReversedSuspendAuthorizeApplicantDetailsComponent,
    ReversedSuspendReturnRequestsComponent,
    ReversedSuspendReturnApplicantDetailsComponent,
    ReversedSuspendReturnRequestViewerComponent,
    ReversedSuspendBlacklistComponent,
    ReversedSuspendBlacklistRequestViewerComponent,
    ReversedSuspendBlacklistApplicantComponent,
    ReversedSuspendBlacklistDocumentsComponent,
    ReversedSuspendBlacklistVerificationComponent,
    ReversedSuspendBlacklistVerificationViewerComponent,
    ReversedSuspendBlacklistVerifyApplicantComponent,
    ReversedSuspendBlacklistVerifyDocumentComponent,
    ReversedSupendBlacklistAuthorizationComponent,
    ReversedSuspBlackAuthApplicantComponent,
    ReversedSuspBlackAuthRequestViewerComponent,
    ReversedSuspendBlacklistReturnComponent,
    ReversedSuspendBlacklistReturnApplicantsComponent,
    ReversedSuspendBlacklistReturnRequestViewerComponent,
    SuspendBlacklistProcessComponent,
    SuspendBlacklistProcessViewerComponent,
    SuspendBlacklistAuthorizationComponent,
    SuspendBlacklistVerificationComponent,
    SuspendBlacklistAuthorizationViewerComponent,
    SuspendBlacklistReturnDataComponent,
    SuspendBlacklistRerurnViewerComponent,
    SuspendBlacklistReturnRequestsComponent,
    CardPreviewPopupComponent,
    DocumentViwerPopupComponent,
    DocumentViewerPopupComponent,
    AddNewComponent,
    InventoryDetailsComponent,
    InventorySearchTableComponent,
    PaymentDetailComponent,
    EditInventryDetailsComponent,
    AuditTraceDetailsComponent,
    BoarderMgtComponent,
    BoarderPopupComponent,
    SmsReportComponent,
    SmsMgtComponent,
    SmsSearchTableComponent,
    SmsPopupComponent,
    StageChangePopupComponent,
    StageChangeMgtComponent,
    StudioStatusReportComponent
  ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        PublicModule,
        DashboardModule,
        NgbModule,
        HttpClientModule,
        ReactiveFormsModule,
        FormsModule,
        ChartsModule,
        MatTableModule,
        MatPaginatorModule,
        BrowserAnimationsModule,
        MatFormFieldModule,
        MatInputModule,
        ChartsModule,
        AngularDualListBoxModule,
        ImageViewerModule,
        Ng2PaginationModule,
        MatIconModule,
        MatTabsModule,
        MatDialogModule,
        MatCardModule,
        MatCheckboxModule,
        MatSortModule,
        MatDatepickerModule,
        OwlDateTimeModule,
        OwlNativeDateTimeModule,
        NgxDropzoneModule,
        NgxUiLoaderModule,
        NgWizardModule.forRoot(ngWizardConfig),
        Ng2LoadingSpinnerModule.forRoot({}),
        MatTableExporterModule,
        MatProgressBarModule,
        MatProgressSpinnerModule
    ],
  providers: [HttpClient,
    AuthService,
    SessionService,
    SysConfigService,
    UserRoleService,
    UserroleCategoryService,
    EmployeeDesignationService,
    PageService,
    SectionService,
    SubSectionService,
    UserPrivilegeService,
    SystemUserService,
    EmployeeService,
    SystemUserService,
    WorkflowStageService,
    OperationPrivilageService,
    ProvinceService,
    DistrictService,
    CityService,
    NationalityService,
    TokenStorageService,
    InactivityService,
    {
      provide: APP_INITIALIZER,
      useFactory: initConfig,
      deps: [AppConfig],
      multi: true,
    },
    SearchRequestService,
    {provide : LocationStrategy , useClass: HashLocationStrategy}
  ],
  entryComponents: [
    UserRolePopupComponent,
    EmployeePopupComponent,
    SystemUserPopupComponent,
    DocumentViewerPopupComponent,
    EmployeeDesignationPopupComponent,
    ProvincePopupComponent,
    CityPopupComponent,
    DistrictPopupComponent,
    NationalityPopupComponent,
    DocumentViewerComponent,
    UserRoleCategoryPopupComponent,
    RemarkComponent,
    FwdRemarkComponent,
    ReturnRemarkComponent,
    ApproveChecklistComponent,
    UserRoleCategoryPopupComponent,
    RequestSearchHistoryComponent,
    ReturnRequestComponent,
    RemarksComponent,
    ReturnRequestDetailsComponent,
    ReversedReturnRequestComponent,
    ReversedRemarksComponent,
    ReversedReturnRequestDetailsComponent,
    BlacklistDocsViewerComponent,
    SuspendRemarksComponent,
    CardPreviewPopupComponent,
    DocumentViwerPopupComponent,
    BlacklistApproveChecklistComponent,
    AddNewComponent,
    EditInventryDetailsComponent,
    SmsPopupComponent,
    StageChangePopupComponent,
    BoarderPopupComponent],
  bootstrap: [AppComponent]
})
export class AppModule { }
